export default __webpack_public_path__ + "static/media/title-winners_zh_tw@2x.ddcc9490.png";